const classNames = {
  field: 'row -input',
  label: 'col-sm-6 text-sm-right',
  inputWrapper: 'col-sm-6',
}
export default classNames
